export default "__VITE_ASSET__DDtGOrdi__"